module.exports = __webpack_public_path__ + "img/logo.5fe05c31.png";